/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { CollectionsSidebar } from "../components/collection-sidebar/CollectionsSidebar";
import { CollectionsHeader } from "../components/collections/CollectionsHeader";
import { useSelector, useDispatch } from "react-redux";
import { useAnalytics } from "../hooks/useAnalytics";
import config from "environment";
import { apiGetSupportedApps } from "../services/ShareService";
import {
  setSupportedApps,
  selectSupportedApps,
} from "../redux/features/connectedApps/connectedAppsSlice";
import { selectIsMobile, setIsMobile } from "../redux/features/appData";
import * as screens from "../utils/screens";

// this is the OAuth route so we have no password
export const ThemeContext = createContext();

const showContents = config.showContents;

export default function Root() {
  useAnalytics();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { collectionId: currentCollectionId } = useParams();

  const storeUser = useSelector((state) => state.appData.user);
  const supportedApps = useSelector(selectSupportedApps);

  const isMobile = useSelector(selectIsMobile);

  const initialState = {};
  const [rootData, setRootData] = useState(initialState);

  const handleWindowResize = () => {
    dispatch(setIsMobile(screens.isMobile()));
  };

  useEffect(() => {
    if (isMobile) {
      navigate("/logout");
    }
  }, [isMobile]);

  useEffect(() => {
    dispatch(setIsMobile(screens.isMobile()));
    window.addEventListener("resize", handleWindowResize);
    console.log("supportedApps: ", supportedApps);
    if (supportedApps && supportedApps.length === 0) {
      (async () => {
        const theApps = await apiGetSupportedApps();

        dispatch(setSupportedApps(theApps));
      })();
    }

    // if not logged in bounce there
    if (!storeUser) {
      navigate("/login");
      return;
    }

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (storeUser) {
  //       const pendoPayload = {
  //         visitor: { ...storeUser, env: window.location.hostname },
  //         account: { ...storeUser, env: window.location.hostname },
  //       };

  //       if (!!window?.pendo) {
  //         // eslint-disable-next-line no-undef
  //         window.pendo.identify(pendoPayload);
  //       }
  //     }
  //   }, 2000);
  // }, [storeUser]);

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  console.log("[Root/main] storeUser: ", storeUser);

  return (
    <>
      <div id="main-collections">
        {/* {!currentCollectionId && 
          <CollectionsSidebar />
        }
        {currentCollectionId &&
          <CollectionContextSidebar />
      } */}
        <CollectionsSidebar />

        <div id="collections-content-body">
          <CollectionsHeader />

          {/* {!currentCollectionId &&
                        <CollectionsHeader />

          }
          {currentCollectionId &&
            <CollectionContextHeader />
          } */}
          <Outlet context={[rootData, setRootData]} />
        </div>
      </div>

      <Toaster />
    </>
  );
}
